/* eslint-disable */
import { useState, useEffect, useCallback } from 'react';

export function useApi(fetchFn, deps = []) {
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);
  const [tick,    setTick]    = useState(0);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    fetchFn()
      .then(result => { if (!cancelled) setData(result); })
      .catch(e     => { if (!cancelled) setError(e.message); })
      .finally(()  => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [...deps, tick]); // eslint-disable-line

  const refetch = useCallback(() => setTick(t => t + 1), []);

  return { data, loading, error, refetch };
}